// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back-next-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 36px;
}
.back-next-container > div {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
}
.back-next-container > div p, .back-next-container > div h1.title {
  margin: 0;
}
.back-next-container > div h1.title {
  font-family: "Proxima Nova", sans-serif;
  font-size: 40px;
  font-weight: 700;
  width: 650px;
  text-align: center;
  color: var(--secondary-color-1);
}
.back-next-container > div .back-button, .back-next-container > div .next-button {
  position: absolute;
}
.back-next-container > div .next-button {
  width: 120px;
  right: 160px;
}
.back-next-container > div .next-button.submit {
  width: 200px;
}
.back-next-container > div .back-button {
  font-family: "Proxima Nova", sans-serif;
  color: var(--secondary-color-3);
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  left: 160px;
}
.back-next-container > div .back-button:hover {
  opacity: 0.75;
}
.back-next-container > div button:disabled {
  background: none;
  background-color: var(--secondary-color-4) !important;
  box-shadow: none;
}
.back-next-container .subtitle {
  font-family: "Proxima Nova", sans-serif;
  text-align: center;
  font-size: 20px;
  color: var(--secondary-color-3);
}

.confirm-property-container,
.request-container,
.select-agents-container,
.choose-agent-container,
.invite-agent-container,
.featured-agents-container,
.request-review-container,
.select-buyer-container,
.invite-buyer-container,
.showing-calendar-container {
  animation: fadeIn 1s;
}

.agent-profile--container {
  display: flex;
  align-items: center;
}
.agent-profile--container .agent-profile--image {
  height: 110px;
  width: 110px;
  position: relative;
}
.agent-profile--container .agent-profile--image:first-child {
  margin-right: -25px;
}
.agent-profile--container .agent-profile--image:last-child {
  margin-left: -25px;
}
.agent-profile--container .agent-profile--image:nth-child(2) {
  height: 170px;
  width: 170px;
  border: 5px solid white;
  z-index: 2;
}
.agent-profile--container .agent-profile--image.solo .agent-profile--avatar {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.agent-profile--container .agent-profile--image .agent-profile--avatar, .agent-profile--image.solo .agent-profile--avatar {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.agent-profile--container .agent-profile--image .agent-profile--avatar > img, .agent-profile--image.solo .agent-profile--avatar > img {
  height: 28px;
  width: 28px;
  margin-bottom: -14px;
}

.agent-profile--container .agent-profile--image:nth-child(2) .agent-profile--avatar > img {
  width: 40px;
  height: 40px;
  margin-bottom: -20px;
}

.agent-profile--image.solo {
  height: 100px;
  width: 100px;
}

.agent-profile--info {
  width: 100%;
}
.agent-profile--info .name, .agent-profile--info .company-name {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 24px;
  margin: 0;
}
.agent-profile--info .company-name {
  font-size: 16px;
  color: var(--secondary-color-2);
}
.agent-profile--info .email, .agent-profile--info .phone {
  display: flex;
  align-items: center;
}
.agent-profile--info .email > img, .agent-profile--info .phone > img {
  width: 10px;
  height: 10px;
  margin-right: 10px;
}
.agent-profile--info .email > span, .agent-profile--info .phone > span {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: var(--secondary-color-3);
  width: 205px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .back-next-container > div {
    padding-top: 100px;
  }
  .back-next-container > div h1.title {
    font-size: 30px;
  }
  .back-next-container > div .back-button, .back-next-container > div .next-button {
    position: absolute;
    top: 0;
  }
  .back-next-container > div .next-button {
    right: 20px;
    width: 100px;
    height: 40px;
    font-size: 16px;
  }
  .back-next-container > div .back-button {
    font-size: 16px;
    left: 20px;
    top: 0px;
  }
  .back-next-container > div .back-button:hover {
    opacity: 0.75;
  }
  .back-next-container .subtitle {
    font-size: 16px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .back-next-container > div {
    padding-top: 100px;
  }
  .back-next-container > div h1.title {
    font-size: 30px;
  }
  .back-next-container > div .back-button, .back-next-container > div .next-button {
    position: absolute;
    top: 0;
  }
  .back-next-container > div .next-button {
    right: 20px;
    width: 100px;
    height: 40px;
    font-size: 16px;
  }
  .back-next-container > div .back-button {
    font-size: 16px;
    left: 20px;
    top: 0px;
  }
  .back-next-container > div .back-button:hover {
    opacity: 0.75;
  }
  .back-next-container .subtitle {
    font-size: 16px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .back-next-container > div {
    padding-top: 70px;
  }
}
@media (width: 1024px) and (max-height: 833px) {
  .back-next-container > div {
    padding-top: 50px;
  }
  .back-next-container > div h1.title {
    font-size: 30px;
  }
  .back-next-container > div .back-button, .back-next-container > div .next-button {
    position: absolute;
    top: 0;
  }
  .back-next-container > div .next-button {
    right: 40px;
    width: 100px;
    height: 40px;
    font-size: 20px;
  }
  .back-next-container > div .back-button {
    font-size: 20px;
    left: 40px;
    top: 0px;
  }
  .back-next-container > div .back-button:hover {
    opacity: 0.75;
  }
  .back-next-container .subtitle {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/showingRequest.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAEI;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AACQ;EAAc,SAAA;AAEtB;AADQ;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAGZ;AADQ;EACI,kBAAA;AAGZ;AADQ;EACI,YAAA;EACA,YAAA;AAGZ;AAFY;EACI,YAAA;AAIhB;AADQ;EACI,uCAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAGZ;AAFY;EACI,aAAA;AAIhB;AADQ;EACI,gBAAA;EACA,qDAAA;EACA,gBAAA;AAGZ;AAAI;EACI,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AAER;;AAEA;;;;;;;;;;EAUI,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AAER;AADQ;EACI,mBAAA;AAGZ;AADQ;EACI,kBAAA;AAGZ;AADQ;EACI,aAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;AAGZ;AAAQ;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AAEZ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AADJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,oBAAA;AAAJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AACJ;;AAGA;EACI,aAAA;EACA,YAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;AACI;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AACR;AACI;EACI,eAAA;EACA,+BAAA;AACR;AACI;EACI,aAAA;EACA,mBAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAEZ;AAAQ;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEZ;;AAGA;EACI;IAAK,UAAA;EACP;EAAE;IAAO,UAAA;EAGT;AACF;AC1KY;ED4KJ;IACI,kBAAA;EACV;EAAU;IACI,eAAA;EAEd;EAAU;IACI,kBAAA;IACA,MAAA;EAEd;EAAU;IACI,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EAEd;EAAU;IACI,eAAA;IACA,UAAA;IACA,QAAA;EAEd;EADc;IACI,aAAA;EAGlB;EACM;IACI,eAAA;EACV;AACF;AChMY;EDqKJ;IACI,kBAAA;EA8BV;EA7BU;IACI,eAAA;EA+Bd;EA7BU;IACI,kBAAA;IACA,MAAA;EA+Bd;EA7BU;IACI,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EA+Bd;EA7BU;IACI,eAAA;IACA,UAAA;IACA,QAAA;EA+Bd;EA9Bc;IACI,aAAA;EAgClB;EA5BM;IACI,eAAA;EA8BV;AACF;AC7NY;EDqMJ;IACI,iBAAA;EA2BV;AACF;AC3NY;EDsMJ;IACI,iBAAA;EAwBV;EAvBU;IACI,eAAA;EAyBd;EAvBU;IACI,kBAAA;IACA,MAAA;EAyBd;EAvBU;IACI,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EAyBd;EAvBU;IACI,eAAA;IACA,UAAA;IACA,QAAA;EAyBd;EAxBc;IACI,aAAA;EA0BlB;EAtBM;IACI,eAAA;EAwBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.back-next-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 36px;\n    > div {\n        display: flex;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        p, h1.title { margin: 0; }\n        h1.title { \n            font-family: 'Proxima Nova', sans-serif;\n            font-size: 40px;\n            font-weight: 700;\n            width: 650px;\n            text-align: center;\n            color: var(--secondary-color-1);\n        }\n        .back-button, .next-button {\n            position: absolute;\n        }\n        .next-button { \n            width: 120px;\n            right: 160px;\n            &.submit {\n                width: 200px;\n            }\n        }\n        .back-button {\n            font-family: 'Proxima Nova', sans-serif;\n            color: var(--secondary-color-3);\n            font-size: 20px;\n            font-weight: 700;\n            cursor: pointer;\n            left: 160px;\n            &:hover {\n                opacity: .75;\n            }\n        }\n        button:disabled {\n            background: none;\n            background-color: var(--secondary-color-4) !important;\n            box-shadow: none;\n        }\n    }\n    .subtitle {\n        font-family: 'Proxima Nova', sans-serif;\n        text-align: center;\n        font-size: 20px;\n        color: var(--secondary-color-3);\n    }\n}\n\n.confirm-property-container,\n.request-container,\n.select-agents-container,\n.choose-agent-container,\n.invite-agent-container,\n.featured-agents-container,\n.request-review-container,\n.select-buyer-container,\n.invite-buyer-container,\n.showing-calendar-container {\n    animation: fadeIn 1s;\n}\n\n.agent-profile--container {\n    display: flex;\n    align-items: center;\n    .agent-profile--image {\n        height: 110px;\n        width: 110px;\n        position: relative;\n        &:first-child {\n            margin-right: -25px;\n        }\n        &:last-child {\n            margin-left: -25px;\n        }\n        &:nth-child(2) {\n            height: 170px;\n            width: 170px;\n            border: 5px solid white;\n            z-index: 2;\n        }\n\n        &.solo .agent-profile--avatar {\n            width: 100%;\n            height: 100%;\n            background-position: center;\n            background-repeat: no-repeat;\n            background-size: cover;\n            border-radius: 10px;\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n        }\n        \n    }\n}\n\n.agent-profile--container .agent-profile--image .agent-profile--avatar, .agent-profile--image.solo .agent-profile--avatar{\n    width: 100%;\n    height: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n.agent-profile--container .agent-profile--image .agent-profile--avatar > img, .agent-profile--image.solo .agent-profile--avatar > img  {\n    height: 28px;\n    width: 28px;\n    margin-bottom: -14px;\n}\n.agent-profile--container .agent-profile--image:nth-child(2) .agent-profile--avatar > img {\n    width: 40px;\n    height: 40px;\n    margin-bottom: -20px;\n}\n\n\n.agent-profile--image.solo {\n    height: 100px;\n    width: 100px;\n}\n\n.agent-profile--info {\n    width: 100%;\n    .name, .company-name {\n        font-family: 'Proxima Nova', sans-serif;\n        font-weight: 700;\n        font-size: 24px;\n        margin: 0;\n    }\n    .company-name {\n        font-size: 16px;\n        color: var(--secondary-color-2);\n    }\n    .email, .phone {\n        display: flex;\n        align-items: center;\n        > img {\n            width: 10px;\n            height: 10px;\n            margin-right: 10px;\n        }\n        > span {\n            font-family: 'Proxima Nova', sans-serif;\n            font-weight: 600;\n            font-size: 16px;\n            color: var(--secondary-color-3);\n            width: 205px;\n            text-align: left;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n}\n\n@keyframes fadeIn {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n\n@include media(mobile, tablet) {\n    .back-next-container {\n        > div {\n            padding-top: 100px;\n            h1.title { \n                font-size: 30px;\n            }\n            .back-button, .next-button {\n                position: absolute;\n                top: 0;\n            }\n            .next-button { \n                right: 20px;\n                width: 100px;\n                height: 40px;\n                font-size: 16px;\n            }\n            .back-button {\n                font-size: 16px;\n                left: 20px;\n                top: 0px;\n                &:hover {\n                    opacity: .75;\n                }\n            }\n        }\n        .subtitle {\n            font-size: 16px;\n        }\n    }\n}\n\n@include media(tablet) {\n    .back-next-container {\n        > div {\n            padding-top: 70px;\n        }\n    }\n}\n\n@include media(nitty-gritt) {\n    .back-next-container {\n        > div {\n            padding-top: 50px;\n            h1.title { \n                font-size: 30px;\n            }\n            .back-button, .next-button {\n                position: absolute;\n                top: 0;\n            }\n            .next-button { \n                right: 40px;\n                width: 100px;\n                height: 40px;\n                font-size: 20px;\n            }\n            .back-button {\n                font-size: 20px;\n                left: 40px;\n                top: 0px;\n                &:hover {\n                    opacity: .75;\n                }\n            }\n        }\n        .subtitle {\n            font-size: 16px;\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
